import { LitElement, html, svg } from 'lit';

export class IconBackWheelDrive24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Bakhjuls drivverk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 2h4M19 4.5H5M12 19.5H5M2 23h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1ZM19 17a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-5ZM19 19.5H5M10 22h4"></path></svg>`; }
}
if (!customElements.get('f-icon-back-wheel-drive24', IconBackWheelDrive24)) {
  customElements.define('f-icon-back-wheel-drive24', IconBackWheelDrive24);
}